import React from 'react';
import { IconProps } from './types';

const WhatsappChatIcon: React.FC<IconProps> = props => {
  const { fillColor = 'var(--bg-primary)', width = 24, height = 24 } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.6099 13.5653V4.96057C20.6099 4.48031 20.2197 4.1001 19.7494 4.1001H6.63214"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M16.5676 17.2672H8.02286C7.9128 17.2672 7.82275 17.3573 7.82275 17.4674V19.3184C7.84276 19.4985 7.62264 19.5885 7.49257 19.4585L5.43143 17.3273C5.43143 17.3273 5.34138 17.2672 5.29135 17.2672H3.47034C2.99007 17.2672 2.60986 16.877 2.60986 16.4068V7.81201C2.60986 7.33174 3.00008 6.95153 3.47034 6.95153H16.5876C17.0679 6.95153 17.4481 7.34175 17.4481 7.81201V16.4068C17.4481 16.887 17.0579 17.2672 16.5876 17.2672H16.5676Z"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M5.70166 10.6237H14.3364"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M5.70166 13.3352H11.2047"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default WhatsappChatIcon;
